import { render, staticRenderFns } from "./ShopsTab.vue?vue&type=template&id=3e62b070&"
import script from "./ShopsTab.vue?vue&type=script&lang=ts&"
export * from "./ShopsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports